<template>
  <div>
    <CRow>
      <CCol sm="12">
        <ChallengesTable
          :items="challenges"
          hover
          striped
          border
          small
          fixed
          caption="Concursos"
          @refresh="refreshItems"
          :permissions="permissions"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ChallengesTable from '../../components/challenges/ChallengesTable.vue'
import ws from '../../services/challenges';
import account_ws from '../../services/account';
import store from '../../store'

export default {
  name: 'Challenges',
  components: { ChallengesTable },
  data: function () {
		return {
            challenges: [],
            permissions: null
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      this.challenges = response.data;
    }

    let response2 = await account_ws.getInfo(); 

    if(response2.type == "success"){
      this.permissions = response2.data.user.permissions;
    }

    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.challenges = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
